import { Button, Stack, Typography } from "@mui/material";
import PromptDialog from "@entrilia/shared/components/dialog/PromptDialog";
import PromptDialogHeader from "@entrilia/shared/components/dialog/PromptDialogHeader";
import DialogButtons from "@entrilia/shared/components/DialogButtons";
import WarningDialogIcon from "@entrilia/shared/icons/WarningDialogIcon";

interface Props {
  open: boolean;
  templateName: string;
  onClose: () => void;
  onTryAgain: () => void;
}

export default function ErrorApplyingTemplateDialog({ open, onClose, onTryAgain, templateName }: Props) {
  return (
    <PromptDialog open={open} sx={{ width: 514, height: 310, p: 0 }}>
      <PromptDialogHeader onClose={onClose} text="Error" />
      <Stack sx={{ p: 3, flex: 1, alignItems: "center", justifyContent: "center", gap: 2 }}>
        <WarningDialogIcon sx={{ width: 80, height: 80 }} />
        <Stack sx={{ gap: 1, textAlign: "center" }}>
          <Typography variant="h6">{`"${templateName}" template not applied`}</Typography>
          <Typography color="textSecondary">Please try again or cancel the template application.</Typography>
        </Stack>
      </Stack>
      <DialogButtons onCancel={onClose}>
        <Button variant="outlined" color="primary" onClick={onTryAgain}>
          Try Again
        </Button>
      </DialogButtons>
    </PromptDialog>
  );
}
